// 辅助函数

export function classNames(...classes: (string | boolean | undefined)[]): string {
  return classes.filter(Boolean).join(' ')
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function generateId(): string {
  return Math.random().toString(36).substring(2, 9)
}

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

/**
 * Arco Form `validate()` 失败时 reject 的通常不是 `Error`，而是带 `errors` 字段的对象（按字段存校验信息）。
 * 与 `mutate` / API 抛出的 `Error` 放在同一个 catch 时，优先识别 `errors` 再回退到 `err.message`。
 */
export function getFormValidateErrorMessage(err: unknown): string {
  if (err == null) return '操作失败'
  if (typeof err === 'object' && err !== null && 'errors' in err) {
    const { errors } = err as { errors?: unknown }
    if (errors && typeof errors === 'object' && !Array.isArray(errors)) {
      for (const val of Object.values(errors as Record<string, unknown>)) {
        if (typeof val === 'string' && val) return val
        if (val && typeof val === 'object' && 'message' in val) {
          const m = (val as { message?: unknown }).message
          if (Array.isArray(m) && m.length > 0) {
            const first = m[0]
            if (first != null && String(first)) return String(first)
          } else if (m != null && String(m)) {
            return String(m)
          }
        }
      }
    }
  }
  if (err instanceof Error && err.message) return err.message
  return '操作失败'
}
